import {DomainObject} from 'shared/store';
import {action, observable} from 'mobx';
import User from '../users/User';
import { v4 as uuidv4 } from 'uuid';

class PerformanceReviewNote extends DomainObject {
  @observable text;
  @observable lexicalState;
  @observable visibleToReviewee = false;
  @observable createdByUser;

  @action merge(other) {
    this.id = this.id ? this.id : uuidv4();
    super.merge(other, {
      createdByUser: User
    });
  }
}

export default PerformanceReviewNote;
